import { render, staticRenderFns } from "./StockCatalogsCreation.vue?vue&type=template&id=12596fc3"
import script from "./StockCatalogsCreation.vue?vue&type=script&lang=js"
export * from "./StockCatalogsCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports